<div *ngIf="!hasSelectedLocation">
  <input
    class="input-legacy"
    type="text"
    placeholder="{{ 'MAINTENANCES.LOCATION_PLACEHOLDER' | translate }}"
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
  />

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedLocation()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option
      *ngFor="let location of locations"
      [value]="location.id"
      [matTooltip]="location.address.formattedAddress"
      [matTooltipShowDelay]="500"
    >
      {{ location.address.formattedAddress }}
    </mat-option>
    <mat-option *ngIf="!locations.length">
      {{ 'MAINTENANCES.LOCATION_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
</div>

<div class="selected-input" *ngIf="hasSelectedLocation">
  <input class="input-legacy" type="text" disabled [value]="selectedLocation.address.formattedAddress" />

  <button mat-icon-button class="cancel-button" *ngIf="hasSelectedLocation" (click)="deselectLocation()">
    <mat-icon>cancel</mat-icon>
  </button>
</div>
